import { GameCard } from '../components/GameCard';
import { Link } from 'react-router-dom';

const games = [
  {
    title: 'Was kostet dieses Haus?',
    description: 'Schätze den Wert verschiedener Immobilien in Südtirol. Teste dein Gespür für den Markt und lerne dabei einiges über Immobilienpreise.',
    image: 'https://images.unsplash.com/photo-1734169065204-127b2b724c7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBhbHBpbmUlMjBob3VzZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzQyNTc4NzZ8MA&ixlib=rb-4.1.0&q=85',
    path: '/tippspiele/was-kostet-dieses-haus',
    type: 'estimation',
    featured: true
  },
  {
    title: 'Neubau oder Sanierung?',
    description: 'Die große Frage für viele Bauherren: Lieber neu bauen oder das Bestehende sanieren? Finde heraus, was besser zu dir passt.',
    image: 'https://images.pexels.com/photos/5691521/pexels-photo-5691521.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    path: '/tippspiele/neubau-oder-sanierung',
    type: 'decision',
    featured: true
  },
  {
    title: 'Was kostet eine Sanierung?',
    description: 'Schätze die Kosten typischer Sanierungsprojekte in Südtirol und lerne, worauf es bei der Budgetplanung ankommt.',
    image: 'https://images.unsplash.com/photo-1489515229412-1f3a8f08dc34?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxob21lJTIwcmVub3ZhdGlvbiUyMGNvbnN0cnVjdGlvbiUyMHdvcmtlcnMlMjBtb2Rlcm58ZW58MHx8fHwxNzc0MjU3ODc5fDA&ixlib=rb-4.1.0&q=85',
    path: '/haus-und-bau/was-kostet-eine-sanierung',
    type: 'estimation'
  },
  {
    title: 'Wohnung kaufen oder mieten?',
    description: 'Die ewige Frage – beantworte ein paar Fragen zu deiner Situation und erhalte eine persönliche Einschätzung.',
    image: 'https://images.unsplash.com/photo-1705321963943-de94bb3f0dd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwbGl2aW5nJTIwcm9vbSUyMGludGVyaW9yJTIwZGVzaWdufGVufDB8fHx8MTc3NDI1Nzg3OXww&ixlib=rb-4.1.0&q=85',
    path: '/immobilien/wohnung-kaufen-oder-mieten',
    type: 'quiz'
  },
  {
    title: 'Wohnen in Südtirol',
    description: 'Welche Region in Südtirol passt am besten zu deinem Lebensstil? Finde es spielerisch heraus.',
    image: 'https://images.unsplash.com/photo-1768464395439-25b2ef151f80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxpdGFsaWFuJTIwZG9sb21pdGVzJTIwbW91bnRhaW4lMjB2aWxsYWdlJTIwc2NlbmljfGVufDB8fHx8MTc3NDI1Nzg4MHww&ixlib=rb-4.1.0&q=85',
    path: '/suedtirol/wohnen-in-suedtirol',
    type: 'quiz'
  }
];

export default function Tippspiele() {
  return (
    <div className="section-spacing" data-testid="tippspiele-page">
      <div className="container-wide">
        {/* Header */}
        <div className="max-w-2xl mb-12">
          <nav className="text-sm text-[#64748B] mb-4" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-[#0284C7]">Start</Link>
            <span className="mx-2">/</span>
            <span className="text-[#0F172A]">Tippspiele</span>
          </nav>
          
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] mb-4 font-[var(--font-heading)]">
            Tippspiele & Quiz
          </h1>
          <p className="text-lg text-[#475569]">
            Teste dein Wissen rund um Immobilien, Bauen und Wohnen. 
            Unsere interaktiven Spiele helfen dir, bessere Einschätzungen zu treffen.
          </p>
        </div>

        {/* Games Grid */}
        <div className="bento-grid">
          {games.map((game, index) => (
            <GameCard key={index} {...game} />
          ))}
        </div>

        {/* Info Box */}
        <div className="mt-16 bg-[#F8FAFC] rounded-xl p-8 border border-[#E2E8F0]">
          <h2 className="text-xl font-semibold text-[#0F172A] mb-4 font-[var(--font-heading)]">
            Über unsere Tippspiele
          </h2>
          <div className="prose prose-slate max-w-none">
            <p className="text-[#475569] mb-4">
              Unsere Tippspiele und Quiz sind keine typischen Wissensspiele – sie sind 
              <strong> Entscheidungshelfer</strong>. Ob du wissen willst, ob sich eine 
              Sanierung lohnt, was eine Immobilie wert sein könnte oder welche Wohnform 
              zu dir passt: Hier bekommst du spielerisch Orientierung.
            </p>
            <p className="text-[#475569]">
              Alle Inhalte sind speziell für den <strong>Südtiroler Markt</strong> konzipiert 
              und basieren auf regionalen Erfahrungswerten. Die Spiele werden regelmäßig 
              aktualisiert und erweitert.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
